/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description checkIsUsableSimilarListing helper
 */

import type { Listable } from '@zcode/state-type'

export interface CheckIsUsableSimilarListingArgs {
  checkIsFavorited: (listable: Listable) => boolean
  checkIsMessaged: (listable: Listable) => boolean
}

export const checkIsUsableSimilarListing =
  ({ checkIsFavorited, checkIsMessaged }: CheckIsUsableSimilarListingArgs) =>
  (listable: Listable) => {
    return !(
      listable.isShortTerm ||
      listable.isMmExclude ||
      (typeof checkIsFavorited === 'function' && checkIsFavorited(listable)) ||
      (typeof checkIsMessaged === 'function' && checkIsMessaged(listable))
    )
  }
